import styled, { css } from 'styled-components';
import { transparentize, lighten, darken } from 'polished';
import { device } from 'styles/device';
import { ButtonBase } from 'components/Button/styles';

interface ColumnContentProps {
  $columns: string;
}
interface BlocoHeaderProps {
  $background: number;
}
export const Container = styled.div`
  width: -webkit-fill-available;
  width: -moz-available;
  display: flex;
  flex-direction: column;

  header {
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
  }
`;

export const Content = styled.div`
  padding: 0 15px 0 15px;
  flex: 1 1;
  section {
    padding-bottom: 10px;
  }
`;

export const ContentBase = styled.div`
  padding: 0 15px;
  h4 {
    margin-bottom: 1rem;
  }
  /* flex: 1 1;
  section {
    padding-bottom: 10px;
  } */
`;

export const IpPtColumn = styled.div`
  margin-top: 10px;
  display: flex;
  align-items: center;
  > div {
    &:first-of-type {
      width: -webkit-fill-available;
      margin-right: 10px;
    }
  }
`;
export const ColumnContent = styled.div<ColumnContentProps>`
  display: grid;

  grid-template-columns: 1fr 1fr;
  grid-template-columns: ${props => props.$columns};
  grid-column-start: 1;
  grid-column-end: 2;
  margin-bottom: 10px;
  height: 100%;
  @media ${device.laptopM} {
    grid-template-columns: 1fr;
  }

  > div {
    margin: 0 10px 0 0;
    justify-content: space-between;
  }

  section {
    display: flex;
    justify-content: space-between;

    padding: 0 0 5px 0 !important;
    margin: 0px 0 15px 0;
    border-bottom: 1px solid
      ${props => transparentize(0.5, props.theme.fontColor)};

    &:first-of-type {
      margin: 0px 0 15px 0;
    }

    ${ButtonBase} {
      margin-top: -10px;
    }
  }
`;

export const BlocoHeader = styled.h3<BlocoHeaderProps>`
  text-align: center;
  border-radius: 5px;
  margin-bottom: 10px;
  padding: 5px;
  background: ${props =>
    props.$background === 1
      ? props.theme.daytime.manha
      : props.$background === 2
      ? props.theme.daytime.tarde
      : props.theme.daytime.noite};
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;

  thead {
    tr {
      th {
        text-align: left;
        padding: 10px 0px 10px 0px;
        color: ${props => props.theme.fontColor};
        font-size: 1.0625rem;
        font-weight: 400 !important;
      }
    }
  }

  tbody {
    tr {
      cursor: pointer;
      z-index: 1;
      border-bottom: 0.1px solid
        ${props => transparentize(0.7, props.theme.fontColor)};
      &:last-of-type {
        border-bottom: none;
      }
      td {
        z-index: 2;
        padding: 10px 0px;

        font-size: 1.0625rem;
        color: ${props => props.theme.fontColor};

        button {
          margin: 0;
        }
      }

      &:hover {
        transition: all 0.25s ease;
        ${props =>
          props.theme.name === 'dark'
            ? css`
                background-color: ${props =>
                  lighten(0.03, props.theme.cardBackgroud)};
              `
            : css`
                background-color: ${props =>
                  darken(0.03, props.theme.cardBackgroud)};
              `}
      }
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    gap: 1rem;
  }
`;

export const ProgramaEdit = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 175px);
  h4 {
    margin-bottom: 1rem;
  }
`;

export const BaseEdit = styled.div`
  padding: 0 15px;
  h4 {
    margin-bottom: 1rem;
  }
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: calc(100vh - 175px);

  ul {
    list-style-type: none;
    color: ${props => props.theme.fontColor};
  }
`;

export const BaseView = styled.div`
  padding: 0 15px;
  justify-content: space-between;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 175px);
  h4 {
    &:not(:first-child) {
      margin: 0.5rem auto 0;
      text-align: center;
    }
  }
  img {
    margin-top: 1rem;
    width: 200px;
    border-radius: 5px;
  }
  p {
    font-size: 11px;
    text-align: center;
  }
`;

export const Logo = styled.img`
  display: block;
  margin: 0 auto;
  margin-bottom: 10px;
  width: 150px;
  height: 150px;
`;
